import createAction from '@clearscore/helpers.create-action';

import { ALERTS_SHOW_ALERT, ALERTS_HIDE_ALERT, ALERTS_PARTIAL_HIDE_ALERT } from '../alerts.types';

export const showAlert = (payload) => createAction(ALERTS_SHOW_ALERT, payload);

export const delayedDismissAlert = () => createAction(ALERTS_PARTIAL_HIDE_ALERT);

export const dismissAlert = () => createAction(ALERTS_HIDE_ALERT);
